<template>
  <div class="new-order new-notice-order">
    <div class="header">
      <span class="title">编辑发货通知单</span>
      <div class="control-button">
        <el-button @click="close()">取消</el-button>
        <el-button type="primary" @click="updateDraft" v-if="dataObj.status === 5">保存为草稿</el-button>
        <el-button type="primary" @click="submitDraft" v-if="dataObj.status === 5" :disabled="submitDisable">提交</el-button>
        <el-button type="primary" @click="submit" v-if="dataObj.status !== 5" :disabled="submitDisable">提交</el-button>
      </div>
    </div>
    <div class="body">
      <div class="notice-base">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="基本信息">
            <el-form ref="form" inline>
              <qx-new-form-item :item="baseItemObj.deliveryTime">
                <template>
                  <el-date-picker v-model="dataObj.deliveryTime" type="date"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="deliveryTimePickerOptions"
                                  placeholder="请选择出库日期"/>
                </template>
              </qx-new-form-item>
              <el-form-item label="客户" required>
                <template>
                  <CustomerMassageAutoComplete :value.sync="customerData"
                                                :placeholder="'请选择客户联系人'"
                                                @setValue="setCustomer"
                                                @clear="clearCustomer"/>
                </template>
                <!-- <template>
                    <el-select
                      v-model="customerData"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请选择客户联系人"
                      :remote-method="customerRemoteMethod"
                      :loading="false"
                      style="width: 500px"
                      @change="customerChange">
                      <el-option
                        v-for="item in customerOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </template> -->
              </el-form-item>
              <el-form-item label="联系地址" required>
                <template>
                    <el-input ref="deliveryAddress"
                              v-model="deliveryAddress"
                              placeholder="请选择地址"
                              @focus="addressSelect('delivery')"
                              style="width: 500px"></el-input>
                </template>
              </el-form-item>
              <el-form-item label="账单地址">
                <template>
                  <el-switch
                    v-model="billIsShow"
                    active-color="#13ce66"
                    @change="billIsShowChange">
                  </el-switch>
                </template>
              </el-form-item>
              <el-form-item label="账单地址" v-if="billIsShow">
                <template>
                    <el-input ref="billAddress"
                              v-model="billAddress"
                              placeholder="请选择地址"
                              @focus="addressSelect('bill')"
                              style="width: 500px"></el-input>
                </template>
              </el-form-item>
              <el-form-item label="中转站">
                <el-switch
                    v-model="transferIsShow"
                    active-color="#13ce66"
                    @change="changeTransferInfo">
                </el-switch>
              </el-form-item>
              <el-form-item label="中转站" v-if="transferIsShow">
                <el-input placeholder="请输入中转站"
                        class="transferInfo_input"
                        size="small"
                        v-model="dataObj.transferInfo"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <template>
                  <el-input placeholder="请输入备注"
                      :rows="1"
                      style="width: 500px"
                      type="textarea"
                      v-model.trim="dataObj.remark"/>
                </template>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件信息" name="附件信息">
            <el-form inline>
              <el-form-item label="附件上传">
                <file-upload-list :file-list.sync="saleFile"/>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-divider/>
        <span>物品明细</span>
        <qx-select-table :data="qxList.value.orderDetailsList">
          <el-table-column type="index" label="序号"/>
          <qx-select-table-column prop="saleOrderNo" label="销售订单编号" :disabled="true" width="200">
            <template v-slot:button>
              <el-button type="primary" @click="openOrderDialog"
                :disabled="orderBtnDisabled || (dataObj.status !== 1 && dataObj.status !== 5)">
                选择订单
              </el-button>
            </template>
          </qx-select-table-column>
          <el-table-column prop="goodsNo" label="物品编号"/>
          <qx-select-table-column prop="noticeMainCount"
                                  label="本次通知发货主数量" :is-slot="true">
            <template v-slot="{scope}">
              <qx-input-number v-model="scope.row.noticeMainCount" :controls="false"
                               :precision="2"
                               @focus="onFocus($event)"
                               @blur="blurNoticeMainCount(scope.row, scope.$index)"
                               :ref="'noticeMainCount' + scope.$index"
                               v-if="!utils.notEmptyArr(scope.row.batchList)"
                               :disabled="dataObj.status !== 1 && dataObj.status !== 5"/>
              <span v-else>{{ scope.row.noticeMainCount }}</span>
            </template>
          </qx-select-table-column>
          <qx-select-table-column label="主单位" prop="noticeMainUnit" is-slot>
            <template v-slot="{scope}">
              <select-unit :unit-list="mainUnitList"
                           :default-id="scope.row.noticeMainUnitId"
                           :index="scope.$index"
                           :goods="scope.row"
                           v-on:setUnit="setMainUnit"
                           :disabled="dataObj.status !== 1 && dataObj.status !== 5"/>
            </template>
          </qx-select-table-column>
          <qx-select-table-column prop="remark" label="备注"/>
          <el-table-column prop="goodsWeight" label="重量" :formatter="weightFormatter"/>
          <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
              <div class="table-operator" v-if="!scope.row.isNew">
                <i class="el-icon-third-lajitong" @click="removeOrderDetailsList(scope.$index)"
                  v-if="dataObj.status === 1 || dataObj.status === 5"/>
              </div>
            </template>
          </el-table-column>
        </qx-select-table>
        <div class="total">
          <div><span>总重量：{{totalWeight}}</span></div>
          <div><span>总数量：{{totalQuantity}}</span></div>
        </div>
      </div>
    </div>
    <el-dialog title="销售订单选择" :visible.sync="dialog.orderVisible" width="80%" :close-on-click-modal="false">
      <sale-order-dialog v-if="dialog.orderVisible"
                         @close="closeOrderDialog"
                         @select="selectOrder"
                         :is-selected-order="qxList.value.orderDetailsList"
                         :goods-type="dataObj.goodsType"
                         :cust-name="dataObj.custName"
                         :user-name="dataObj.userName"
                         :unit-list="mainUnitList"
                         :orderOperatorId="dataObj.orderOperatorId"
                         :simpleType="dataObj.simpleType"/>
    </el-dialog>
    <el-drawer
      title="选择地址"
      :visible.sync="addressDrawervisible"
      direction="rtl"
      size="50%"
      class="address_drawer">
      <address-select-drawer :addressList="addressList"
                             :addressType="addressType"
                             :tableIndex="tableIndex"
                             @addressSelectClose="addressSelectClose"
                             @addressSelectSubmit="addressSelectSubmit"
                             @addAddressShow="addAddressShow"
                             ref="addressSelectDrawer"/>
    </el-drawer>
    <el-dialog
      title="新增地址"
      :visible.sync="addressAddVisible"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      center>
      <address-add-dialog @addAddressClose="addAddressClose"
                          @submitAddress="submitAddress"
                          :addressLists="addressLists"
                          :addressType="addressType"
                          v-if="addressAddVisible"
                          ref="addressAddDialog"/>
    </el-dialog>
  </div>
</template>

<script>
/**
 * @Description: 修改发货通知单
 * @Author: 菩萨蛮
 * @Date: 2020/9/29 9:18 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import noticeOrderMixin from '@/mixins/order/NoticeOrderMixin';
import ModifyOrder from '../../../mixins/order/common/ModifyOrder';
import NoticeOrder from '../../../bean/order/NoticeOrder';
import orderOperate from '../../../mixins/order/common/OrderOperate';
import Settlement from '../../../components/order/Settlement';

export default {
  name: 'ModifyNoticeOrderMayang',
  qx: {
    pageType: 'modify',
    order: NoticeOrder
  },
  data() {
    return {
      initFlag: false,
      defaultValue: {
        warehouse: '',
        custName: '',
        userName: ''
      },
      activeName: '基本信息'
    };
  },
  watch: {
      'qxList.value.orderDetailsList.length': {
          handler(newValue, oldValue) {
              if (oldValue === 0) {
                  if (this.qxList.value.orderDetailsList[0].settlePlans) {
                      this.settlePlans = JSON.parse(JSON.stringify(this.qxList.value.orderDetailsList[0].settlePlans));
                  } else {
                      this.settlePlans = JSON.parse(JSON.stringify(this.custSettlePlans));
                  }
              }
          }
      }
  },
  mixins: [orderOperate, ModifyOrder, noticeOrderMixin],
  components: { Settlement },
  methods: {
    async goSubmit(needAudit, data) {
      const { code } = await this.qPut({
        url: this.url,
        data
      });

      if (code === 200) {
        this.$message.success('修改成功！');
        this.close(true);
      } else {
        this.submitDisable = false;
      }
    },
    async setDefaultValue() {
      const { data } = await this.qGet(`${this.url}/${this.$route.params.id}`);
      this.dataObj = {
        ...data,
        ...data.baseInfoV
      };
      if (data.baseInfoV.custId) {
        const { data: custData } = await this.qGet(`customer/info?id=${data.baseInfoV.custId}&status=1,8`);
        if (custData.datas) {
          this.custSettlePlans = custData.datas[0].settlePlans;
        }
      }
      this.logistics = data.logistics;
      this.qxList.value.orderDetailsList = data.orderList.map(item => {
        let copyItem = JSON.parse(JSON.stringify(item));
        const noticeMainCount = item.orderQuantity ? item.orderQuantity : item.noticeMainCount;
        const noticeMainUnit = item.orderUnit ? item.orderUnit : item.noticeMainUnit;
        delete copyItem.orderQuantity;
        delete copyItem.orderUnit;
        return {
            ...copyItem,
            noticeMainCount,
            noticeMainUnit
        }
      });
      this.defaultValue.warehouse = data.baseInfoV.warehouse;
      this.defaultValue.custName = data.baseInfoV.custName;
      this.defaultValue.userName = data.baseInfoV.userName;
      if (data.baseInfoV.settlePlans) {
        this.settlePlans = data.baseInfoV.settlePlans;
      } else {
        this.settlePlans = [{
          ways: '',
          way: '',
          month: '0',
          day: 0,
          percent: '0'
        }]
      }
      this.saleFile = data.logistics ? data.logistics.saleFile : [];
      this.dataObj.orderOperatorName = data.baseInfoV.orderOperatorName;
      this.dataObj.orderOperatorId = data.operatorId;
      // this.customerData = `${data.baseInfoV.custName}/${data.baseInfoV.contactName}/${data.baseInfoV.contactPhone}`;
      if (data.baseInfoV.address && data.baseInfoV.contactName) {
        if (data.baseInfoV.address.province) {
          this.deliveryAddress = `${data.baseInfoV.contactName} ${data.baseInfoV.contactPhone} ${data.baseInfoV.address.province}/${data.baseInfoV.address.city}/${data.baseInfoV.address.county}/${data.baseInfoV.address.street}/${data.baseInfoV.address.other}`;
        } else {
          this.deliveryAddress = `${data.baseInfoV.contactName} ${data.baseInfoV.contactPhone} ${data.baseInfoV.address.other}`;
        }
      }
      if (data.baseInfoV.billAddress && data.baseInfoV.billContactName) {
        if (data.baseInfoV.billAddress.province) {
          this.billAddress = `${data.baseInfoV.billContactName} ${data.baseInfoV.billContactPhone} ${data.baseInfoV.address.province}/${data.baseInfoV.address.city}/${data.baseInfoV.address.county}/${data.baseInfoV.address.street}/${data.baseInfoV.address.other}`;
        } else {
          this.billAddress = `${data.baseInfoV.billContactName} ${data.baseInfoV.billContactPhone} ${data.baseInfoV.address.other}`;
        }
        this.billIsShow = !(this.ifCompare(data.baseInfoV.billAddress, data.baseInfoV.address)
          && data.baseInfoV.billContactName == data.baseInfoV.contactName
          && data.baseInfoV.billContactPhone == data.baseInfoV.contactPhone);
      } else {
        this.billIsShow = false;
      }
      await this.getCustomer(data.baseInfoV.custClueId || data.baseInfoV.custLeadId);
      if (this.dataObj.transferInfo && this.dataObj.transferInfo !== '') {
          this.transferIsShow = true;
      }
      this.initFlag = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.total{
  font-size: 18px;
}
.transferInfo_input{
  width: 500px;
  ::v-deep .el-input__inner{
    height: 40px;
  }
}
::v-deep .el-drawer__header {
  margin-bottom: 0;
}
</style>
